/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./header.vue?vue&type=template&id=8c00e828&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c00e828",
  null
  
)

export default component.exports